var React = require('react');

function Drag (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M21.5 1v24","strokeOpacity":".24","stroke":"#FFF","strokeWidth":"1.5","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M42.69 14.016l-.842-.841-4.84-4.84-.854.854 4.84 4.84-4.811 4.81.841.842 4.81-4.81zM.31 13.984l.842.841 4.84 4.84.854-.854-4.84-4.84 4.811-4.81-.841-.842-4.81 4.81z","fill":"#FFF","fillRule":"nonzero","key":1})]));
}

Drag.defaultProps = {"viewBox":"0 0 43 26"};

module.exports = Drag;

Drag.default = Drag;
